export function browserIsSafari(): boolean {
  return navigator.userAgent.toLowerCase().includes('safari');
}